import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { AlertComponent } from '../alert/alert.component';
import { ToastService } from './toast.service';

@Component({
  selector: 'ps-toast',
  imports: [Toast, AlertComponent],
  providers: [MessageService],
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  private readonly _toastService = inject(ToastService);
  private readonly _messageService = inject(MessageService);

  constructor() {
    effect(() => {
      const message = this._toastService.message();

      if (message) {
        this._messageService.add({
          key: 'ps-toast',
          id: message.id,
          severity: message.variant,
          summary: message.message,
          sticky: message.keepOpen,
          closable: message.showCloseButton,
        });
      }
    });
  }
}
